import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import {
  IS_API_GATEWAY,
  IS_PRIVATE_API,
} from '@personal-area/global/http/models';
import { RecoveryForm } from '@personal-area/global/password';

import { urls } from '../constants/urls';
import { EmailConfirmationParams } from '../models/email';

@Injectable({ providedIn: 'root' })
export class EmailConfirmationApiService {
  private _http = inject(HttpClient);

  public checkEmailToken(Token: string): Observable<EmailConfirmationParams> {
    return this._http.post<EmailConfirmationParams>(
      urls.confirmEmail,
      { Token },
      { context: new HttpContext().set(IS_API_GATEWAY, true) },
    );
  }

  public emailConfirmRequest(
    userId: number,
    data: RecoveryForm,
  ): Observable<void> {
    return this._http.post<void>(urls.requestEmailConfirmation(userId), data, {
      context: new HttpContext()
        .set(IS_PRIVATE_API, true)
        .set(IS_API_GATEWAY, true),
    });
  }
}
